<!--
    课程商品-课程汇总
    作用：展示校区创建的课程列表数据
    组件：AppList、AppList
    版本号: 3.0
-->
<template>
  <div>
    <AppList
      ref="list"
      :list.sync="list"
      :api-type="apiUrl"
      :api="apiUrl"
      title="">
      <AppList
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columnsLive"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="300px"
            class="orgin-btn"
          >
            <template slot-scope="{row}">
              <el-button
                class="opt-btn"
                size="small"
                @click="editSee(row)">课时详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      v-if="dialogDetail"
      :visible.sync="dialogDetail"
      title="课时详情"
      width="1000px">
      <div
        v-loading="showDialog"
        class="dialog-content">
        <div class="top-title">课程名称：{{ curRow.name }}</div>
        <div class="top-title">课程编码：{{ curRow.code }}</div>
        <div class="top-title">课程数：{{ curRow.detail_count }}</div>
        <div>
          <span>分类：</span>
          <el-cascader
            v-model="cascaderVal"
            :options="getCascader"
            :props="{
              value: 'id',
              label: 'name',
              checkStrictly: true,
              children: 'recursive_children',
            }"
            clearable
            @change="handlerCascader"
          />
        </div>
        <div class="packet-hour">
          <el-popover
            v-for="item in packet"
            :key="item.id"
            placement="top"
            width="300"
            trigger="hover">
            <div class="tip-content">
              <div class="tip-title">课时名称:{{ item.result.name }}</div>
              <div class="tip-title">课时标题:{{ item.result.title }}</div>
              <div class="tip-title">课件id:{{ item.result.id }}</div>
            </div>
            <div
              slot="reference"
              class="item">
              <div class="item-top">
                <div class="num">{{ item.sort + 1 }}</div>
                <div class="title">{{ item.result.name }}</div>
              </div>
              <div class="item-bm">
                {{ item.created_at }}
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ConsumptionStatistics',
  data() {
    return {
      list: {},
      apiUrl: '',
      id: this.$route.query.id,
      columnsLive: [
        { prop: 'clients.review_used.name', label: '校区名称' },
        { prop: 'clients.school_code', label: '校区代码' },
        { prop: 'category', label: '课程分类' },
        { prop: 'name', label: '课程名称' },
        { prop: 'code', label: '课程编码' },
        { prop: 'detail_count', label: '课时总数' },
        { prop: 'created_at', label: '创建时间',width:'110px' },
        { prop: 'updated_at', label: '更新时间',width:'110px' },
        { prop: 'sale_status_text', label: '上下架状态' },
      ],
      dialogDetail: false,
      stage_tag_list: [], // 教育阶段
      subject_tag_list: [], // 学科
      showDialog: false,
      getCascader: [],
      cascaderVal: '',
      classHours: [],
      packet: [],
      curRow: {},
    };
  },
  computed: {
    searchArr() {
      return [
        {
          selectValue: this.stage_tag_list ? this.stage_tag_list.map(item => ({ value: item.id, name: item.name })) : [],
          componentType: 'AppSearchStatus',
          searchType: 'stage_tag_id',
          placeholder: '请选择年级',
        },
        {
          selectValue: this.subject_tag_list ? this.subject_tag_list.map(item => ({ value: item.id, name: item.name })) : [],
          componentType: 'AppSearchStatus',
          searchType: 'subject_tag_id',
          placeholder: '请选择科目',
        },
        {
          selectValue: [
            { value: 1, name: '上架' },
            { value: 2, name: '下架' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'sale_status',
          placeholder: '上下架状态',
        },
        { componentType: 'AppSearchColumn',
          searchType: [
            { prop: 'school_name', label: '校区名称' },
            { prop: 'school_code', label: '校区代码' },
            { prop: 'name', label: '课程名称' },
            { prop: 'code', label: '课程编号' },
          ] },
      ];
    },
  },
  created() {
    this.apiUrl = '/api/packet/packet-all-school-list?order[created_at]=desc';
    this.$http.get('/api/tags?order[order]=desc&equal[type]=stage').then(res => this.stage_tag_list = res.items);

    this.$http.get('/api/tags?order[order]=desc&equal[type]=subject').then(res => this.subject_tag_list = res.items);
  },
  methods: {
    // 查看详情
    editSee(row) {
      this.dialogDetail = true;
      this.showDialog = true;
      this.curRow = row;
      this.getCascader = this.clearArrayEmpty(row.detail_category_tree);
      this.$http.get(`/api/packet/detail-get-list?clients_id=${row.clients_id}&equal[packet_id]=${row.id}&order[sort]=asc&per_page=9999`).then((res) => {
        this.showDialog = false;
        this.classHours = res.items;
        this.packet = res.items;
      });
    },
    // 去掉空值
    clearArrayEmpty(data) {
      data && data.forEach((val) => {
        if (val.recursive_children) {
          if (val.recursive_children.length) {
            this.clearArrayEmpty(val.recursive_children);
          } else {
            // eslint-disable-next-line no-param-reassign
            val.recursive_children = undefined;
          }
        }
      });
      return data;
    },
    // 课时详情-根据分类显示数据
    handlerCascader(val) {
      const searchVal = val[val.length - 1];
      const newArr = [];
      this.classHours.forEach((item) => {
        if (item.detail_category_id === searchVal) {
          newArr.push(item);
        }
      });
      this.packet = !searchVal ? this.classHours : newArr;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-content{
  .top-title{
    line-height: 34px;
  }
  .packet-hour{
    margin-top: 20px;
    min-height: 320px;
    .item{
      width: 150px;
      height: 150px;
      box-sizing: border-box;
      border:2px solid #e1e1e1;
      padding: 20px 30px;
      text-align: center;
       background: #e1e1e1;
       font-size: 16px;
       display: inline-block;
       margin: 5px;
       position: relative;
       cursor: pointer;
       &:hover{
         border:2px solid #FAAD14;
       }
      .item-top{
        .num{
          position: absolute;
          left: 5px;
          top:5px;
          width: 24px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          font-size: 14px;
          border-radius: 50%;
          background: #f0f0f0;
          display: inline-block;
        }
        .title{
          width: 100%;
         display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
      }
      .item-bm{
        margin-top: 15px;
      }
    }
  }
}
.tip-content{
  .tip-title{
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseGoods/CourseSummary/index.vue